import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import MarketplaceUserDetail from '../../../MarketplaceHub/MarketplaceUserDetail';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyMarketplaceUserDetail } from './companyMarketplaceApi';

/**
 * Company Marketplace → one employee's/member's redemption profile. Reuses the
 * shared detail page with the company-scoped fetcher (the backend 404s any
 * user who doesn't belong to this company).
 */
const CMarketplaceUserDetail = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>User Marketplace Profile | Shoorah</title>
      </Helmet>
      <MarketplaceUserDetail
        fetcher={fetchCompanyMarketplaceUserDetail}
        backPath={`/${slug}/marketplace/insights/users`}
        backLabel={isB2BFansMode ? 'Back to Members' : 'Back to Employees'}
      />
    </div>
  );
};

export default CMarketplaceUserDetail;
